import React from 'react';
import { Sidebar, Menu } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import MenuItem from './components/menuItem';
import UiButton from '../uiButton';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * Ui sidebar
 * Show a side bar component on the left side.
 * Parameters (Props):
 * @param array menuItems array [
 *   string key
 *   string icon
 *   object cornerIcon => object type cornerIcon
 *   string label
 *   string tooltip
 *   func onClick
 *   bool active
 * ]
 * @param bool showToggle: if showToogle === true then the icon "arrow left" is shown
 *  at top, which allows to hide the sidebar
 * @param bool showLabels: if showLabels === true then the sidebar has the size
 *  "thin" (150px) otherwise the size "very thin" (60px)
 * @param bool showTooltips
 * @param bool visible: this props variable is only relevant when the props.showToggle === true
 *   in this case visible decides if the sidebar is shown at the beginning
 * @param string mode
 */
export default class UiSidebar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClickToggle = this.onClickToggle.bind(this);
    const visible = props.visible !== null ? props.visible : true;
    this.state = {
      visible: props.showToggle ? visible : true,
    };
  }

  /**
   * On click toggle
   */
  onClickToggle() {
    const { visible } = this.state;
    this.setState({
      visible: !visible,
    });
  }

  render() {
    const { menuItems, showToggle, showTooltips, mode, showLabels } =
      this.props;
    const { visible } = this.state;
    const style = {};
    const styleItemMenu = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      style.backgroundColor = colors.SIDER_BAR_MENU_BACKGROUND_COLOR;
      styleItemMenu.color = colors.SIDER_BAR_MENU_COLOR;
    }
    return (
      <div
        className={`sidebar-wrapper${showLabels ? ' thin' : ' very-thin'}`}
        style={style}
      >
        {showToggle && (
          <div className="sidebar-toggle">
            <UiButton
              key="toggle"
              iconName={visible ? 'arrow left' : 'arrow right'}
              onClick={this.onClickToggle}
              mode={mode}
              showLabels={false}
              sizeButton="large"
              basic
            />
          </div>
        )}
        <Sidebar
          as={Menu}
          animation="overlay"
          icon
          inverted={mode === null}
          vertical
          visible={visible}
          width={showLabels ? 'thin' : 'very thin'}
          className="sidebar-panel"
          style={style}
        >
          {menuItems.map((item, index) => {
            let menuItem = (
              <MenuItem
                key={item.key}
                icon={item.icon}
                cornerIcon={item.cornerIcon}
                label={item.label}
                tooltip={item.tooltip}
                onClick={item.onClick}
                active={item.active}
                showTooltips={showTooltips}
                mode={mode}
                showLabels={showLabels}
              />
            );
            menuItem = (
              <menuItem.type
                {...menuItem.props}
                {...(item.key ? { key: item.key } : { key: index.toString() })}
              />
            );
            return menuItem;
          })}
        </Sidebar>
      </div>
    );
  }
}

UiSidebar.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      icon: PropTypes.string,
      cornerIcon: PropTypes.object,
      label: PropTypes.string,
      tooltip: PropTypes.string,
      onClick: PropTypes.func,
      active: PropTypes.bool,
    })
  ).isRequired,
  showToggle: PropTypes.bool,
  showLabels: PropTypes.bool,
  showTooltips: PropTypes.bool,
  visible: PropTypes.bool,
  mode: PropTypes.string,
};

UiSidebar.defaultProps = {
  showToggle: false,
  showLabels: false,
  showTooltips: false,
  visible: null,
  mode: null,
};
